import PropTypes from 'prop-types';
import { withRouter } from 'core/libs/router';

import Link from 'core/components/Link';
import withTheme from 'core/hocs/withTheme';
import Avatar from 'core/components/Avatar';
import AuthorTypeLabel from 'core/components/AuthorTypeLabel';

import themePropTypes from 'core/utils/prop-types/theme';

import styles from './index.styl';

function AuthorCard({ content, theme, location }) {
  const {
    avatar,
    name,
    slug,
    job_title: jobTitle,
    type,
  } = content.attributes;

  const {
    controls: {
      authorsPage: {
        card: {
          name: {
            font,
          },
          linkType,
        },
      },
    },
    colors: {
      primary,
    },
  } = theme;

  const userAvatar = avatar?.attributes?.versions?.original;

  /* TODO заменить string template на утилиту для формирования ссылки */
  return (
    <Link
      to={`${location.pathname}/${slug}`}
      className={styles.link}
      type={linkType}
    >
      <div className={styles.author}>
        <style jsx>{`
          .${styles.authorName}
            font ${font}
          .${styles.jobTitle}
            color ${primary}
        `}</style>
        <Avatar
          src={userAvatar}
          size={60}
        />
        <div className={styles.authorInfo}>
          <span className={styles.authorName}>{name}</span>
          <AuthorTypeLabel type={type} />
          <div className={styles.jobTitle}>
            {jobTitle}
          </div>
        </div>
      </div>
    </Link>
  );
}

const authorsPageContract = `
  {
    colors: {
      primary,
    },
    controls: {
      authorsPage: {
        card: {
          name: {
            font,
          },
          linkType,
        },
      },
    },
  }
`;

AuthorCard.propTypes = {
  /** данные автора */
  content: PropTypes.object.isRequired,
  /** @ignore */
  theme: themePropTypes(authorsPageContract),
  /** @ignore */
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

const AuthorCardWithHOCs = withRouter(withTheme(AuthorCard));
AuthorCardWithHOCs.displayName = 'AuthorCard';

export { AuthorCard as StorybookComponent };
export default AuthorCardWithHOCs;
